<template>
  <div>
    <small style="height: 35px;" class="w-100 border-bottom py-1 px-2 bg-light d-flex align-items-center">
      TOTAL: {{ clients.length }}
    </small>
    <div class="list-group list-group-flush border-bottom" id="list">
      <router-link
        v-for="c in clients"
        :to="'/clients/' + c.id"
        class="list-group-item list-group-item-action flex-row border-bottom"
        :class="{ active: c.id == client.id }"      
        :key="c.id" style="cursor: pointer"
      >
        <div class="d-flex w-100 justify-content-between">
          <div class="mr-3">
            <img v-if="c.logo_url" :src="c.logo_url" />
            <div v-else class="img-placeholder">{{ c.name.substring(0,1) }}</div>
          </div>
          <div class="d-flex w-100 justify-content-between">
            <strong>
              {{ c.nickname }}<br />
              <small style="font-weight: 400">{{ c.number }}</small>
            </strong>
          </div>
        </div>
      </router-link>
    </div>
  </div>
</template>

<script>
  // import store from '@/stores/clients.js'
  import moment from 'moment'

  export default {
    name: 'client-list',

    props: ['clients', 'client'],

    methods: {
      calendar(date) {
        return moment(date).calendar()
      }
    },

    computed: {

    }
  }
</script>

<style scoped>
  #list {
    height: calc(100vh - 82px);
    overflow-y: auto;
  }
  .list-group-item img {
    max-height: 50px;
    border-radius: 15px;
  }

  .list-group-item-action {
    /* background: transparent; */
  }

  .img-placeholder {
    width: 50px;
    height: 50px;
    border-radius: 15px;
    background-color: #f7f7f7;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 30px;
    color: #cfcfcf;
  }
</style>